// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1pFsT","title":"Header_title__3lI20","side":"Header_side__2A8YS"};